import styled from "styled-components";
import PageTemplate from "../component/PageTemplate.tsx";
import ImgBanner from "../assets/img/manufacture/banner.png";
import ImgContent01 from "../assets/img/manufacture/content01.png";
import ImgMoContent01 from "../assets/img/manufacture/mo_content01.png";
import { useContext } from "react";
import { WrapperContext } from "../component/WrapperContext.tsx";

const Main = styled.div`
  width: 100%;
  height: 100%;
  text-align: left;
  padding: ${(props) => (!props.isMobile ? "25px 0 0 10px" : "25px 0 0 0")};
`;

const Content = styled.img`
  width: 100%;
  margin-bottom: 10vh;
`;
const ContentText = styled.div`
  display: block;
  font-family: SCDream5;
  font-size: 17px;
  width: max-content;
  max-width: ${(props) => (!props.isMobile ? "100%" : "fit-content")};
  margin-left: 5px;
  margin-bottom: 20px;
  line-height: 150%;
`;

const Description1 = styled.div`
  font-family: SCDream5;
  font-size: 1vw;
  line-height: 170%;
`;
const Description2 = styled.span`
  font-family: SCDream5;
  font-size: 1vw;
  line-height: 170%;
  color: #ff1d6d;
`;

export default function Manufacture() {
  const { isMobile } = useContext(WrapperContext);

  return (
    <PageTemplate bannerImage={ImgBanner}>
      <Main isMobile={isMobile}>
        <Description1>- 제품1 소개 글입니다.</Description1>
        <br />
        <Description1>- 제품2 소개 글입니다.</Description1>
        <Description1>
          - 제품3 소개 글입니다.
          <Description2> 강조할 텍스트입니다.</Description2>
        </Description1>
        <br />
        <Content src={!isMobile ? ImgContent01 : ImgContent01} />
      </Main>
    </PageTemplate>
  );
}
